import { render, staticRenderFns } from "./BuildingSearchPopup.vue?vue&type=template&id=18fc2077&scoped=true"
import script from "./BuildingSearchPopup.vue?vue&type=script&lang=js"
export * from "./BuildingSearchPopup.vue?vue&type=script&lang=js"
import style0 from "./BuildingSearchPopup.vue?vue&type=style&index=0&id=18fc2077&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc2077",
  null
  
)

export default component.exports